var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.leadId)?_c('CrmLeadDetailApi',{attrs:{"leadId":_vm.leadId,"companyId":_vm.companyId,"stages":_vm.stages,"reasons":_vm.reasons,"users":_vm.users,"serviceTypes":_vm.serviceTypes,"canManage":_vm.canManage}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }